"use client";

import { createContext, useContext } from "react";

const UsdRateContext = createContext<number | null>(null);

export function UsdRateProvider({
  tjsPerUsd,
  children,
}: {
  tjsPerUsd: number;
  children: React.ReactNode;
}) {
  const safe = Number.isFinite(tjsPerUsd) && tjsPerUsd > 0 ? tjsPerUsd : null;
  return <UsdRateContext.Provider value={safe}>{children}</UsdRateContext.Provider>;
}

export function useTjsPerUsd(): number | null {
  return useContext(UsdRateContext);
}
